import { Cell } from "@m4a3/api-client/dist/models/cell.interface";
import { API } from "aws-amplify";
import { Region } from "../aircraft/types";

export const getCells = async (region: string = "IE"): Promise<Cell[]> => {
  return API.get("delivery", `/cell?region=${region}`, {});
};
export const getRegions = async (): Promise<Region[]> => {
  return API.get("delivery", `/region`, {});
};
